import React from "react";

const ErrorBoundaryComponent = () => {
    return <div>
        <h4>An Error has occured!</h4>
    </div>
}

export default ErrorBoundaryComponent;
